// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Az-z","modalContent":"Bz-z","header":"Cz-z","close":"Dz-z"};